import './styles/job-paylaod.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'

import { Icon } from 'semantic-ui-react'

import api from '../redux/api'

export default class JobPayload extends React.Component {
  static propTypes = {
    job: PropTypes.object.isRequired,
  }

  state = {
    error:        null,
    loading:      false,
    presignedUrl: null,
    showHistory:  false,
  }

  handleDownload = (event, index = 0) => {
    event.preventDefault()

    this.setState({ loading: true, error: null, showHistory: false }, () => {
      api.getJobPayloadPresignedUrl({ jobId: this.props.job.id, index }).then((presignedUrl) => {
        this.setState({ presignedUrl, loading: false }, () => {
          this.presignedUrlElement && this.presignedUrlElement.click()

          this.setState({ loading: false, presignedUrl: null }, () => {
            this.presignedUrlElement = null
          })
        })
      }).catch((error) => {
        let errorMessage

        if (error.message) {
          errorMessage = error.message
        } else if (error.errors) {
          errorMessage = error.errors.map((e) => e.message).join('\r\n')          
        } else {
          errorMessage = error
        }
        this.setState({ error: errorMessage, loading: false, presignedUrl: null })
      })
    })
  }

  handleOpenHistory = (event) => {
    event.preventDefault()
    this.setState({ showHistory: true })
  }

  // renderHistory = () => {
  //   const { showHistory } = this.state

  //   const historyClassName = classnames('payload-history', { visible: showHistory })
    
  //   const payloadHistory = this.props.job.payloadHistory    

  //   return (
  //     <div className={historyClassName} tabIndex={0} id="payloadHistory" ref={this.payloadHistory}>
  //       <div className="payload-history-header">

  //       </div>
  //       {
  //         payloadHistory.map(({ component }, index) => {
  //           const key     = `${component}-${index}`
  //           const handler = (event) => this.handleDownload(event, index)

  //           return (
  //             <div key={key} className="payload-history-item">
  //               <a href="/" onClick={handler}>Download Payload</a>
  //               <span>{ component }</span>
  //             </div>
  //           )
  //         })
  //       }
  //     </div>
  //   )
  // }

  handleCloseHistory = () => {
    this.setState({ showHistory: false })
  }

  render() {
    const { job } = this.props
    const { loading, presignedUrl, showHistory, error } = this.state    

    const loadingClassName = classnames('loading-container', { visible: loading })
    const errorClassName   = classnames('error', { visible: error })

    const hasHistory = Array.isArray(job.payloadHistory) && job.payloadHistory.length > 1
    const linkText   = hasHistory
      ? 'Download History'
      : 'Download Payload'

    const linkHandler = hasHistory
      ? this.handleOpenHistory
      : this.handleDownload

    const linkClass = classnames('link-primary', { active: !showHistory })

    const historyContainerClass = classnames('history-container', { visible: showHistory })

    return (
      <div className="job-paylaod">
        <a href="/" className={linkClass} onClick={linkHandler}>{ linkText }</a>

        <div className={loadingClassName}>
          <Icon name="spinner" loading={loading} />
        </div>

        <div className={historyContainerClass}>
          <Icon name="close" onClick={this.handleCloseHistory} />
          {
            (job.payloadHistory || []).map(({ component }, index) => {
              const key     = `${component}-${index}`
              const handler = (event) => this.handleDownload(event, index)

              return (
                <div key={key} className="payload-history-item">
                  <a href="/" onClick={handler}>Download Payload</a>
                  <span>{ component }</span>
                </div>
              )
            })
          }
        </div>

        {
          presignedUrl && <a
            download
            href={presignedUrl}
            className="presigned-url-link"
            ref={(input) => this.presignedUrlElement = input} />
        }
        <div className={errorClassName}>{ error }</div>
      </div>
    )
  }
}